<template>
  <bk-page class="rootPage">

    <bk-view class="view-router">

<!--      <transition name="fadeIn" mode="out-in" appear>-->
<!--        <router-view pageType="navRoot"></router-view>-->
<!--      </transition>-->

      <router-view v-slot="{ Component, route }">
        <transition name="fadeIn" mode="out-in">
<!--          :include="cachedDoms"-->
          <keep-alive :max="5">
            <component :is="Component" :pageType="route.meta?.pageType || 'navRoot'"/>
          </keep-alive>
        </transition>
      </router-view>
    </bk-view>

    <AppTabs></AppTabs>
  </bk-page>
</template>

<script>

	import AppTabs from './subviews/appTabs/appTabs';

	export default {
		name: 'root',
		components: {
			AppTabs
		}
	};
</script>

<style scoped lang="less">

.rootPage {
  min-height: 100vh;
  height: 100vh;

  > .view-router {
    //min-height: 100%;
    height: 100vh;
    overflow-y: auto;
    //overflow-y: scroll;
    padding-bottom: calc(64px + env(safe-area-inset-bottom));
  }
}

</style>